module.exports = __webpack_public_path__ + "img/bbdc-2.d3421570.jpg";